
import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {SweetModal} from 'sweet-modal-vue';
import axiosInstance from '../../helpers/axios';
import session from '@/stores/Session';

@Component({
  components: {
    SweetModal,
  },
})
export default class CollectionItem extends Vue {

  noOfHours: number = 4;

  cancel() {
    // @ts-ignore
    this.$children[0].close();
    this.$emit('close');
  }

  next() {
    this.$emit('next', this.noOfHours);
    // @ts-ignore
    this.$children[0].close();
  }
}
